import React from "react"
import { Link, graphql } from "gatsby"
import * as moment from "moment"
import "moment/locale/fr"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Card, Button } from "react-bootstrap"
import Fade from "react-reveal/Fade"

const Blog = ({ data }) => {
  const { allMarkdownRemark: posts } = data
  return (
    <Layout>
      <SEO title="Blog" />
      <div className="container py-5 blog">
        <div className="row">
          <div className="col-md-12 mb-5">
            <h2>Blog</h2>
          </div>
        </div>
        <Fade bottom cascade>
          <div className="row">
            {posts.edges.map(post => {
              return (
                <div className="col-lg-6 col-md-12 mb-4" key={post.node.id}>
                  <Card>
                    <div className="img-container">
                      {post.node.frontmatter.thumbnail !== null && (
                        <Card.Img
                          variant="top"
                          src={post.node.frontmatter.thumbnail.publicURL}
                        />
                      )}
                    </div>
                    <Card.Body>
                      <Card.Text className="card-time">
                        <small className="text-muted">
                          {moment(post.node.frontmatter.date).format("LL")}
                        </small>
                      </Card.Text>
                      <Card.Title>
                        <strong>{post.node.frontmatter.title}</strong>
                      </Card.Title>
                      <Card.Text>{post.node.excerpt}</Card.Text>
                      <Link to={post.node.frontmatter.slug}>
                        <Button variant="primary">Lire la suite</Button>
                      </Link>
                    </Card.Body>
                  </Card>
                </div>
              )
            })}
          </div>
        </Fade>
      </div>
    </Layout>
  )
}

export default Blog

export const pageQuery = graphql`
  query AllBlogPosts {
    allMarkdownRemark(
      sort: { order: DESC, fields: frontmatter___date }
      limit: 1000
    ) {
      edges {
        node {
          id
          excerpt
          frontmatter {
            title
            slug
            date
            thumbnail {
              relativePath
              publicURL
            }
          }
        }
      }
    }
  }
`
